import Swiper from 'swiper';
import nextSvg from '../../../assets/svg/arrow-right.svg';
import prevSvg from '../../../assets/svg/arrow-left.svg';

export default Array.from(document.querySelectorAll('.media-slider > .media-slider__slides')).map((slider) => {
	const wrapper = slider.querySelector('.media-slider__slides-wrap');
	const slides = wrapper.querySelectorAll('.media-slider__slide');

	if (!wrapper || !slides) {
		return;
	}

	slider.classList.add('swiper-container');
	wrapper.classList.add('swiper-wrapper');
	// wrapper.classList.add('swiper-counter');
	slides.forEach(slide => slide.classList.add('swiper-slide'));

	slider.insertAdjacentHTML(
		'beforeend',
		`<nav class="media-slider__pagination"></div>`
	);

	var names = [];
				var elementList = document.querySelectorAll('.swiper-slide  .promotion__slides  .promotions__card-slider-name');
				elementList.forEach(elementList => {
					console.log('elementList: ', elementList.innerText);
					names.push(elementList.innerText);
				  });
	return new Swiper(slider, {
		direction: 'horizontal',
		autoHeight: slider.dataset.autoHeight ? true : false,
		speed: 600,
		spaceBetween: 0,
		loop: false,
		breakpoints: {
			768: {
				spaceBetween: 10,
			}
		},
		pagination: {
			el: ".media-slider__pagination",
			clickable: true,
			renderBullet: function (index, className) {
				//return '<span class="' + className + '">' + (names[index]) + '</span>';
				return '<div class="pagination__text ' + className + ' "><span class="pagination-index">'+ ('0' + (index + 1).toString().slice(-5)) + '</span><span class="pagination-kicker ">' + (names[index])+ '</span></div></div>';
			  },	  
		},
      	on: {
			init: function () {
				document.querySelector( '.swiper-container' )
				.insertAdjacentHTML('afterbegin','<div class="swiper-counter"><span class="count">'+ ('0' + (this.realIndex + 1)).toString().slice(-2) +'</span>/<span class="total">'+ ('0' + (this.slides.length)).toString().slice(-2) +'</span></div>' );
			},
			slideChange: function () {
				document.querySelector( '.swiper-counter' )
				.innerHTML = '<span class="count">'+ ('0' + (this.realIndex + 1)).toString().slice(-2) +'</span>/<span class="total">'+ ('0' + (this.slides.length)).toString().slice(-2)  +'</span>' ;
			}
		},
	});
});
